import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom"; // styles
import "./App.css";
import Start from "./pages/start/Start";
import Negocios from "./pages/negocios/Negocios";
import Dashboard from "./pages/restaurantes/dashboard/Dashboard";
import Mesas from "./pages/restaurantes/mesas/Mesas";
import Checador from "./pages/restaurantes/checador/Checador";
import Meseros from "./pages/restaurantes/meseros/Meseros";
import Resenas from "./pages/restaurantes/resenas/Resenas";
import Menu from "./pages/trucks/menu/Menu";
import ConfigTrucks from "./pages/trucks/configuracion/ConfigTrucks";
import TurneroTrucks from "./pages/trucks/turnero/TurneroTrucks";
import QRTurno from "./pages/trucks/qr-turno/QRTurno";
import QRChecador from "./pages/trucks/qr-checador/QRChecador";
import VentasOrdenes from "./pages/trucks/ventas-ordenes/VentasOrdenes";
import Calificaciones from "./pages/trucks/calificaciones/Calificaciones";
import CalificacionesPedidos from "./pages/trucks/calificacionesPedidos/CalificacionesPedidos";
import ConfigAdminTrucks from "./pages/adminTrucks/configuracion/ConfigAdminTrucks";
import Puestos from "./pages/adminTrucks/puestos/Puestos";
import GeneradorQR from "./pages/adminTrucks/QRGenerador/GeneradorQR";
import Login from "./pages/login/Login";
import Reportes from "./pages/Reportes/Reportes";
import Filtros from "./pages/Reportes/Filtros/Filtros";
import Register from "./pages/register/Register";
import Signup from "./pages/signup/Signup";
import Project from "./pages/project/Project";
import Navbar from "./components/Navbar";
import Aviso from "./pages/aviso/aviso";
import Pagos from "./pages/client_side/Pagos";
import { useContext } from "react";
import { AuthContext } from "./context/AuthContext";
import { history } from "./helpers/history";
import { PrivateRoute, NoAllowAuthUsers } from "./components/PrivateRoute";
import Inventario from "./pages/trucks/inventario/inventario";
import Personal from "./pages/restaurantes/personal/Personal";
import Galeria from "./pages/restaurantes/galeria/Galeria";
import VentasXDia from "./pages/Reportes/Filtros/VentasXDia";
import VentasXEmpleado from "./pages/Reportes/Filtros/VentasXEmpleado";
import RecPass from "./pages/Recuperacion/RecPass";
import HistorialCajas from "./pages/trucks/turnero/Historial/HistorialCajas";
import { useEffect } from "react";
import Promociones from "./pages/trucks/promociones/Promociones";
import Cocina from "./pages/cocina/Cocina";

function App() {
  window.convertir = require("numero-a-letras");
  const { authIsReady } = useContext(AuthContext);
  const { employee, register } = useContext(AuthContext);
  window.convertir = require("numero-a-letras");
  history.navigate = useNavigate();
  history.location = useLocation();
  useEffect(() => {
    const color = document.querySelector(".show");
    if (color) {
      color.className = "navbar-collapse collapse";
      const bt = document.querySelector(".navbar-toggler");
      if (bt) {
        bt.className = "navbar-toggler collapsed";
      }
    }
  }, [history.location]);

  return (
    <div className="App">
      {authIsReady &&
        employee === undefined &&
        employee !== null &&
        register && (
          <>
            {!window.location.href.includes("pruebapagos") ? <Navbar /> : <></>}
            <Routes>
              <Route
                path="/reportes"
                element={
                  <PrivateRoute>
                    <Reportes />
                  </PrivateRoute>
                }
              />
              <Route
                path="/historialCajas"
                element={
                  <PrivateRoute>
                    <HistorialCajas />
                  </PrivateRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/negocios"
                element={
                  <PrivateRoute>
                    <Negocios />
                  </PrivateRoute>
                }
              />
              <Route
                path="/personal"
                element={
                  <PrivateRoute>
                    <Personal />
                  </PrivateRoute>
                }
              />
              <Route
                path="/mesas"
                element={
                  <PrivateRoute>
                    <Mesas />
                  </PrivateRoute>
                }
              />
              <Route
                path="/checador"
                element={
                  <PrivateRoute>
                    <Checador />
                  </PrivateRoute>
                }
              />
              <Route
                path="/meseros"
                element={
                  <PrivateRoute>
                    <Meseros />
                  </PrivateRoute>
                }
              />
              <Route
                path="/resenas"
                element={
                  <PrivateRoute>
                    <Resenas />
                  </PrivateRoute>
                }
              />
              <Route
                path="/menu"
                element={
                  <PrivateRoute>
                    <Menu />
                  </PrivateRoute>
                }
              />
              <Route
                path="/filtros"
                element={
                  <PrivateRoute>
                    <Filtros />
                  </PrivateRoute>
                }
              />
              <Route
                path="/VentasTurno"
                element={
                  <PrivateRoute>
                    <VentasXDia />
                  </PrivateRoute>
                }
              />
              <Route
                path="/Promociones"
                element={
                  <PrivateRoute>
                    <Promociones />
                  </PrivateRoute>
                }
              />
              <Route
                path="/VentasEmpleado"
                element={
                  <PrivateRoute>
                    <VentasXEmpleado />
                  </PrivateRoute>
                }
              />
              <Route
                path="/galeria"
                element={
                  <PrivateRoute>
                    <Galeria />
                  </PrivateRoute>
                }
              />
              <Route
                path="/config"
                element={
                  <PrivateRoute>
                    <ConfigTrucks />
                  </PrivateRoute>
                }
              />
              <Route
                path="/inventario"
                element={
                  <PrivateRoute>
                    <Inventario />
                  </PrivateRoute>
                }
              />
              <Route
                path="/qr-checador-trucks"
                element={
                  <PrivateRoute>
                    <QRChecador />
                  </PrivateRoute>
                }
              />
              <Route
                path="/qr-turno-trucks"
                element={
                  <PrivateRoute>
                    <QRTurno />
                  </PrivateRoute>
                }
              />
              <Route
                path="/turnero"
                element={
                  <PrivateRoute>
                    <TurneroTrucks />
                  </PrivateRoute>
                }
              />
              <Route
                path="/cocina"
                element={
                  <PrivateRoute>
                    <Cocina />
                  </PrivateRoute>
                }
              />
              <Route
                path="/ventas-ordenes-trucks"
                element={
                  <PrivateRoute>
                    <VentasOrdenes />
                  </PrivateRoute>
                }
              />
              <Route
                path="/calificaciones"
                element={
                  <PrivateRoute>
                    <Calificaciones />
                  </PrivateRoute>
                }
              />
              <Route
                path="/calificacionesPedidos"
                element={
                  <PrivateRoute>
                    <CalificacionesPedidos />
                  </PrivateRoute>
                }
              />
              <Route
                path="/config-admin-trucks"
                element={
                  <PrivateRoute>
                    <ConfigAdminTrucks />
                  </PrivateRoute>
                }
              />
              <Route
                path="/generador-qr-admin"
                element={
                  <PrivateRoute>
                    <GeneradorQR />
                  </PrivateRoute>
                }
              />
              <Route
                path="/puestos-admin"
                element={
                  <PrivateRoute>
                    <Puestos />
                  </PrivateRoute>
                }
              />
              <Route path="/create" element={<PrivateRoute></PrivateRoute>} />
              <Route
                path="/project/:id"
                element={
                  <PrivateRoute>
                    {" "}
                    <Project />{" "}
                  </PrivateRoute>
                }
              />
              <Route
                path="/login"
                element={
                  <NoAllowAuthUsers>
                    <Login />
                  </NoAllowAuthUsers>
                }
              />
              <Route
                path="/register"
                element={
                  <NoAllowAuthUsers>
                    <Register />
                  </NoAllowAuthUsers>
                }
              />
              <Route path="/aviso" element={<Aviso />} />
              <Route path="/recuperacion" element={<RecPass />} />
              <Route path="/pruebapagos/:idOrden" element={<Pagos />} />
              <Route path="*" element={<Navigate to="/negocios" />} />
            </Routes>
          </>
        )}
      {authIsReady && employee !== undefined && employee !== null && (
        <>
          <Navbar />
          <Routes>
            <Route
              path="/negocios"
              element={
                <PrivateRoute>
                  <Negocios />
                </PrivateRoute>
              }
            />
            <Route
              path="/qr-turno-trucks"
              element={
                <PrivateRoute>
                  <QRTurno />
                </PrivateRoute>
              }
            />
            <Route
              path="/ventas-ordenes-trucks"
              element={
                <PrivateRoute>
                  <VentasOrdenes />
                </PrivateRoute>
              }
            />
            <Route
              path="/historialCajas"
              element={
                <PrivateRoute>
                  <HistorialCajas />
                </PrivateRoute>
              }
            />
            <Route
              path="/calificaciones"
              element={
                <PrivateRoute>
                  <Calificaciones />
                </PrivateRoute>
              }
            />
            <Route
              path="/calificacionesPedidos"
              element={
                <PrivateRoute>
                  <CalificacionesPedidos />
                </PrivateRoute>
              }
            />
            {employee.personal !== false && employee.personal !== undefined ? (
              <Route
                path="/personal"
                element={
                  <PrivateRoute>
                    <Personal />
                  </PrivateRoute>
                }
              />
            ) : (
              <></>
            )}
            {employee.mesas !== false && employee.mesas !== undefined ? (
              <Route
                path="/mesas"
                element={
                  <PrivateRoute>
                    <Mesas />
                  </PrivateRoute>
                }
              />
            ) : (
              <></>
            )}
            {employee.checador !== false && employee.checador !== undefined ? (
              <Route
                path="/checador"
                element={
                  <PrivateRoute>
                    <Checador />
                  </PrivateRoute>
                }
              />
            ) : (
              <></>
            )}
            {employee.meseros !== false && employee.meseros !== undefined ? (
              <Route
                path="/meseros"
                element={
                  <PrivateRoute>
                    <Meseros />
                  </PrivateRoute>
                }
              />
            ) : (
              <></>
            )}
            {employee.resenas !== false && employee.resenas !== undefined ? (
              <Route
                path="/resenas"
                element={
                  <PrivateRoute>
                    <Resenas />
                  </PrivateRoute>
                }
              />
            ) : (
              <></>
            )}
            {employee.menu !== false && employee.menu !== undefined ? (
              <Route
                path="/menu"
                element={
                  <PrivateRoute>
                    <Menu />
                  </PrivateRoute>
                }
              />
            ) : (
              <></>
            )}
            {employee.galeria !== false && employee.galeria !== undefined ? (
              <Route
                path="/galeria"
                element={
                  <PrivateRoute>
                    <Galeria />
                  </PrivateRoute>
                }
              />
            ) : (
              <></>
            )}
            {employee.configuracion !== false &&
            employee.configuracion !== undefined ? (
              <Route
                path="/config"
                element={
                  <PrivateRoute>
                    <ConfigTrucks />
                  </PrivateRoute>
                }
              />
            ) : (
              <></>
            )}
            {employee.inventario !== false &&
            employee.inventario !== undefined ? (
              <Route
                path="/inventario"
                element={
                  <PrivateRoute>
                    <Inventario />
                  </PrivateRoute>
                }
              />
            ) : (
              <></>
            )}
            {(employee.turnero !== false && employee.turnero !== undefined) ||
            employee.barra ? (
              <Route
                path="/turnero"
                element={
                  <PrivateRoute>
                    <TurneroTrucks />
                  </PrivateRoute>
                }
              />
            ) : (
              <></>
            )}
            <Route
              path="/login"
              element={
                <NoAllowAuthUsers>
                  <Login />
                </NoAllowAuthUsers>
              }
            />
            <Route
              path="/register"
              element={
                <NoAllowAuthUsers>
                  <Register />
                </NoAllowAuthUsers>
              }
            />
            <Route path="/aviso" element={<Aviso />} />
            <Route path="/" element={<Start />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/recuperacion" element={<RecPass />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </>
      )}
      {!employee && !register && (
        <>
          {!window.location.href.includes("pruebapagos") ? <Navbar /> : <></>}
          <Routes>
            <Route
              path="/login"
              element={
                <NoAllowAuthUsers>
                  <Login />
                </NoAllowAuthUsers>
              }
            />
            <Route
              path="/register"
              element={
                <NoAllowAuthUsers>
                  <Register />
                </NoAllowAuthUsers>
              }
            />
            <Route path="/signup" element={<Signup />} />
            <Route path="/recuperacion" element={<RecPass />} />
            <Route path="/" element={<Start />} />
            {/* <Route
              path="/caracteristicas"
              element={
                <NoAllowAuthUsers>
                  <Caracteristicas />
                </NoAllowAuthUsers>
              }
            />
            <Route
              path="/nosotros"
              element={
                <NoAllowAuthUsers>
                  <Nosotros />
                </NoAllowAuthUsers>
              }
            />
            <Route
              path="/planes"
              element={
                <NoAllowAuthUsers>
                  <Planes />
                </NoAllowAuthUsers>
              }
            />
            <Route
              path="/casos"
              element={
                <NoAllowAuthUsers>
                  <Casos />
                </NoAllowAuthUsers>
              }
            /> */}
            <Route path="/pruebapagos/:idOrden" element={<Pagos />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </>
      )}
    </div>
  );
}
export default App;
